import React from "react";
import "./style.css";

const CartItem = ({ item }) => {
  return (
    <div className="a-cart-item-component">
      <div className="a-product-name">
        <h3>{item.product_name}</h3>
      </div>
      {item.items.map((i) => {
        return [
          <div className="a-product-all">
            <div className="a-product-item">
              <p className="a-item-name">{i.item_name}</p>{" "}
              <p className="a-item-quantity" style={{textAlign: 'left'}}>Quantity: {i.quantity}</p>
            </div>
            <p className="a-item-price">ብር {i.total_item_price}</p>
          </div>
        ];
      })}
    </div>
  );
};

export default CartItem;
